import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=ae989014"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=ae989014&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports